import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import { MarketmanagerAdminModule } from '../../admin/admin.module';
import {
    MarketdateStatusService,
    MarketdateStatusPopupService,
    MarketdateStatusComponent,
    MarketdateStatusDetailComponent,
    MarketdateStatusDialogComponent,
    MarketdateStatusPopupComponent,
    MarketdateStatusDeletePopupComponent,
    MarketdateStatusDeleteDialogComponent,
    marketdateStatusRoute,
    marketdateStatusPopupRoute,
} from './';

const ENTITY_STATES = [
    ...marketdateStatusRoute,
    ...marketdateStatusPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        MarketmanagerAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateStatusComponent,
        MarketdateStatusDetailComponent,
        MarketdateStatusDialogComponent,
        MarketdateStatusDeleteDialogComponent,
        MarketdateStatusPopupComponent,
        MarketdateStatusDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateStatusComponent,
        MarketdateStatusDialogComponent,
        MarketdateStatusPopupComponent,
        MarketdateStatusDeleteDialogComponent,
        MarketdateStatusDeletePopupComponent,
    ],
    providers: [
        MarketdateStatusService,
        MarketdateStatusPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateStatusModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status.module.ts